module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-100.0da4b8c5.woff2";